import axios from 'axios';
import { ECSku } from 'types';

export const fetchECSkus = (brandId: number) =>
  axios.get<ECSku[]>(`/api/brands/${brandId}/ec_skus`);

export const updateECSku = (brandId: number, skuId: number, weight: number) =>
  axios.post(`/api/brands/${brandId}/ec_skus/${skuId}`, { weight });
